import { Container } from "@mui/material";
import React from "react";
import UdyogAadhaarForm from "../components/Forms/UdyogAadhaarForm";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import "../Style/Theme/index.css";

export default function UdyogAadhaar() {
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={4} />
        <IntroCard
          title="Enter Udyam Registration"
          subtitle="Please enter your Udyam Registration number to proceed"
          img="/assets/udhyogAdhar.svg"
        />
        <UdyogAadhaarForm />
      </Container>
    </>
  );
}
